import { Component, Injector, OnInit} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AllocationSheetsServiceProxy } from '@shared/service-proxies/service-proxies';
import { PermissionCheckerService } from 'abp-ng2-module';

@Component({
  selector: 'app-allocation-activities-report',
  templateUrl: './allocation-activities-report.component.html',
  styleUrls: ['./allocation-activities-report.component.less']
})
export class AllocationActivitiesReportComponent extends AppComponentBase implements OnInit {
  summary;
  outstanding;
  overdue;
  summaryLoading = false;
  outstandingLoading = false;
  overdueLoading = false;

  searchVisible = false;

  constructor(
    injector: Injector,
    private _allocationSheetServiceProxy: AllocationSheetsServiceProxy,
    private _permissionChecker: PermissionCheckerService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getSummary();
    this.getOutstanding();
    this.getOverdue();
  }

  toggleSearch(): void {
    this.searchVisible = !this.searchVisible;

    if (!this.searchVisible) {
      this.getOverdue();
    }
  }

  private getSummary(): void {
    this.summaryLoading = true;
    if (this._permissionChecker.isGranted("Pages.AllocationSheetsSummary.Foreman")) {
      this._allocationSheetServiceProxy
      .getForemanAllocationSheetsSummary()
      .subscribe((summaryData) => {
        this.summary = summaryData;
        this.summaryLoading = false;
      });
    }
    else if (this._permissionChecker.isGranted("Pages.AllocationSheetsSummary.Supervisor")) {
      this._allocationSheetServiceProxy
      .getSupervisorAllocationSheetsSummary()
      .subscribe((summaryData) => {
        this.summary = summaryData;
        this.summaryLoading = false;
      });
    }
    else if (this._permissionChecker.isGranted("Pages.AllocationSheetsSummary.ProjectAdministrator")) {
      this._allocationSheetServiceProxy
      .getProjectAdministratorAllocationSheetsSummary()
      .subscribe((summaryData) => {
        this.summary = summaryData;
        this.summaryLoading = false;
      });
    }
  }

  getOutstanding() {
    this.outstandingLoading = true;
    if (this._permissionChecker.isGranted("Pages.OutstandingResubmittedAllocationSheets.Foreman")) {
      this._allocationSheetServiceProxy
      .getForemanOutstandingResubmittedAllocationSheets()
      .subscribe((outstandingData) => {
        this.outstanding = outstandingData;
        this.outstandingLoading = false;
      });
    }
    else if (this._permissionChecker.isGranted("Pages.OutstandingResubmittedAllocationSheets.Supervisor")) {
      this._allocationSheetServiceProxy
      .getSupervisorOutstandingResubmittedAllocationSheets()
      .subscribe((outstandingData) => {
        this.outstanding = outstandingData;
        this.outstandingLoading = false;
      });
    }
    else if (this._permissionChecker.isGranted("Pages.OutstandingResubmittedAllocationSheets.ProjectAdministrator")) {
      this._allocationSheetServiceProxy
      .getProjectAdministratorOutstandingResubmittedAllocationSheets()
      .subscribe((outstandingData) => {
        this.outstanding = outstandingData;
        this.outstandingLoading = false;
      });
    }
  }

  getOverdue(event = null) {
    let search = null;

    if (event) {
      search = event.target.value;
    }

    this.overdueLoading = true;
    if (this._permissionChecker.isGranted("Pages.OverdueActivities.Foreman")) {
      this._allocationSheetServiceProxy
      .getForemanOverdueActivities(search)
      .subscribe((overdue) => {
        this.overdueLoading = false;
        this.overdue = overdue.items;
      });
    }
    else if (this._permissionChecker.isGranted("Pages.OverdueActivities.Supervisor")) {
      this._allocationSheetServiceProxy
      .getSupervisorOverdueActivities(search)
      .subscribe((overdue) => {
        this.overdueLoading = false;
        this.overdue = overdue.items;
      });
    }
    else if (this._permissionChecker.isGranted("Pages.OverdueActivities.ProjectAdministrator")) {
      this._allocationSheetServiceProxy
      .getProjectAdministratorOverdueActivities(search)
      .subscribe((overdue) => {
        this.overdueLoading = false;
        this.overdue = overdue.items;
      });
    }
  }

  onMySettingsModalSaved(){

  }
}
